const SESSION_TIMEOUT_MS = 60_000;
const KEYS = {
  absentSince: "@PartyGames:ausenteDesde",
  lastActivity: "@PartyGames:ultimaAtividadeVisivel",
  room: "@PartyGames:roomCode",
  username: "@PartyGames:username",
  soloScreen: "@PartyGames:soloTela",
  term: "@PartyGames:termoSoloSessao",
  puzzle: "@PartyGames:quebraCabecaSoloSessao",
  stopLegacy: "@PartyGames:stopSoloEmAndamento",
  stop: "@PartyGames:stopSoloSessao",
};
const PUZZLE_PROGRESS_PREFIX = "quebraCabeca_progresso_";
const hasStorage = () => typeof window !== "undefined" && window.localStorage;

export function marcarStopSoloEmAndamento() {
  if (!hasStorage()) return;
  localStorage.setItem(KEYS.stopLegacy, "1");
  localStorage.setItem(KEYS.lastActivity, String(Date.now()));
}

export function limparMarcacaoStopSolo() {
  if (hasStorage()) localStorage.removeItem(KEYS.stopLegacy);
}

export function hasActiveSession() {
  if (!hasStorage()) return false;
  return Boolean(
    localStorage.getItem(KEYS.room) ||
      localStorage.getItem(KEYS.term) ||
      localStorage.getItem(KEYS.puzzle) ||
      localStorage.getItem(KEYS.stop) ||
      localStorage.getItem(KEYS.stopLegacy),
  );
}

export function clearExpiredSession() {
  if (!hasStorage()) return false;
  if (!hasActiveSession()) {
    localStorage.removeItem(KEYS.absentSince);
    localStorage.removeItem(KEYS.lastActivity);
    return false;
  }

  const absentSince = Number(localStorage.getItem(KEYS.absentSince));
  const lastActivity = Number(localStorage.getItem(KEYS.lastActivity));
  const reference = absentSince || lastActivity;
  if (!reference || Date.now() - reference <= SESSION_TIMEOUT_MS) return false;

  Object.values(KEYS).forEach((key) => localStorage.removeItem(key));
  const progressKeys = [];
  for (let index = 0; index < localStorage.length; index += 1) {
    const key = localStorage.key(index);
    if (key?.startsWith(PUZZLE_PROGRESS_PREFIX)) progressKeys.push(key);
  }
  progressKeys.forEach((key) => localStorage.removeItem(key));
  return true;
}

export function installSessionLifecycle() {
  if (!hasStorage()) return () => {};
  clearExpiredSession();

  const markAbsent = () => {
    if (hasActiveSession() && !localStorage.getItem(KEYS.absentSince)) {
      localStorage.setItem(KEYS.absentSince, String(Date.now()));
    }
  };
  const markVisible = () => {
    if (document.visibilityState !== "visible") return;
    if (clearExpiredSession()) {
      window.location.replace("/");
      return;
    }
    if (hasActiveSession()) {
      localStorage.removeItem(KEYS.absentSince);
      localStorage.setItem(KEYS.lastActivity, String(Date.now()));
    }
  };
  const handleVisibility = () =>
    document.visibilityState === "hidden" ? markAbsent() : markVisible();

  document.addEventListener("visibilitychange", handleVisibility);
  window.addEventListener("pagehide", markAbsent);
  window.addEventListener("pageshow", markVisible);
  markVisible();
  const interval = window.setInterval(markVisible, 5000);

  return () => {
    window.clearInterval(interval);
    document.removeEventListener("visibilitychange", handleVisibility);
    window.removeEventListener("pagehide", markAbsent);
    window.removeEventListener("pageshow", markVisible);
  };
}
